const f = ["#e2ca9d", "#ff7701", "#e23e1c", "#941400"], e = ["#e2ca9d", "#ff7701", "#ffb526", "#e23e1c", "#941400"], c = [
  "#e2ca9d",
  "#ffb626",
  "#ff7701",
  "#e23e1c",
  "#bf270a",
  "#941400"
];
export {
  f as TRAFFIC_VOLUME_RED_4,
  e as TRAFFIC_VOLUME_RED_5,
  c as TRAFFIC_VOLUME_RED_6
};
//# sourceMappingURL=index.es5569.js.map
